import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmIcon from '~/components/atoms/Global/MdmIcon';
export default {
  name: 'IconTextLink',
  components: {
    MdmIcon: MdmIcon
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    to: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'light',
      validator: function validator(value) {
        return ['dark', 'light'].includes(value);
      }
    },
    tracking: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    themeClass: function themeClass() {
      return "theme-".concat(this.theme);
    }
  }
};